export default "__VITE_ASSET__pRiih9ZW__"